<template>
  <div>
    <section class="bg-white">
      <div class="bg content">
        <div class="intro">
          <p class="intro__title">Expositions</p>
          <p>
            Un espace galerie d’art offre une exposition régulièrement
            renouvelée d’œuvres d’artistes contemporains.
          </p>
          <p>
            Laissez-nous votre email pour recevoir des informations sur les
            prochaines expositions.
          </p>
          <form ref="form" @submit.prevent="sendEmail" class="form">
            <div>
              <input
                type="email"
                v-model="email"
                name="email"
                placeholder="Votre email"
                required
              /><br />
              <span v-if="msg.email" class="error">{{ msg.email }}</span>
            </div>
            <button type="submit">Envoyer</button>
          </form>
          <p v-if="successMsg" class="form-success">{{ successMsg }}</p>
          <p v-if="errorMsg" class="form-error">{{ errorMsg }}</p>
        </div>
        <div v-for="(item, index) in expo" :key="index">
          <h2
            v-if="item.section"
            class="section-title"
            :class="{
              now: item.section === 'En ce moment',
            }"
          >
            {{ item.section }}
          </h2>
          <div class="two-column">
            <div class="image">
              <picture>
                <source :srcset="toWebp(item.image)" type="image/webp" />
                <img
                  :src="toJpg(item.image)"
                  :alt="item.title || ''"
                  loading="lazy"
                />
              </picture>
            </div>
            <div class="text">
              <h3 class="title">
                <a
                  v-if="item.title_link"
                  :href="item.title_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="artist-link"
                  >{{ item.title }}
                </a>
                <span v-else>{{ item.title }}</span>
              </h3>
              <p
                v-show="item.name_multiline"
                v-html="item.name_multiline"
                class="name"
              ></p>
              <p>
                <a
                  v-if="item.name_link"
                  :href="item.name_link"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="name artist-link"
                  >{{ item.name }}</a
                >
                <span class="name" v-else>{{ item.name }}</span>
                <span v-show="item.post" class="post">{{ item.post }}</span>
              </p>
              <p v-show="item.post_multiline" v-html="item.post_multiline"></p>
              <p class="name" v-show="item.date">{{ item.date }}</p>
              <div v-show="item.note" class="note">
                {{ item.note }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import emailjs from "emailjs-com";
export default {
  name: "Expositions",
  data() {
    return {
      email: "",
      msg: {},
      successMsg: "",
      errorMsg: "",
      expo: [
        {
          section: "En ce moment",
          image: "img/expo/agnes-tiollier.jpg",
          title: "La Nature en lumière",
          date: "01/09 – 30/11/2026",
          name: "Agnès Tiollier",
          post_multiline:
            "Inspirée par la nature, l’artiste lyonnaise trouve son inspiration dans des jardins et paysages baignés de lumière. Parmi ses sources d’inspiration notamment : le jardin de Monet à Giverny et le célèbre jardin Majorelle d’Yves Saint Laurent.",
        },
        {
          section: "2026",
          image: "img/expo/favrene_2026.jpg",
          title: "Favrène",
          title_link: "https://www.aralya.fr/expositions/favrene/",
          date: "07/05 - 30/06/2026",
          note: "Soirée-rencontre avec l’artiste : le jeudi 11 juin 18h-20h30",
          post_multiline:
            "Favrene, artiste peintre lyonnais de 91 ans, déploie une œuvre puissante et immédiatement reconnaissable, où formes et signes s’entrechoquent dans un langage visuel singulier à la fois libre et maîtrisé. « Pas la peine de courir les océans pour trouver l’oiseau bleu » : cette phrase, inscrite dans son travail, reflète une vision profondément personnelle, tournée vers l’essentiel et l’intuition.",
        },
        {
          image: "img/expo/koba_2026.jpg",
          title: "Un certain regard",
          date: "31/01 - 28/03/2026",
          name: "Ariel KOBA",
          name_link: "https://koba.dictionnairedesartistescotes.com/",
          post_multiline: "La sobriété entre abstraction et figuration",
        },
        {
          image: "img/expo/carole-gourrat-2.jpg",
          title: "Carole Gourrat",
          title_link: "https://carolegourrat.com/",
          date: "29/10 - 25/01/2026",
          post_multiline:
            "<p>Artiste peintre basée à Mâcon, Carole Gourrat développe un univers pictural onirique et sensible où la nature occupe une place centrale. Fleurs, feuillages et créatures imaginaires se mêlent dans des compositions baroques, à la frontière du rêve et du réel.</p><p>Inspirée autant par la peinture ancienne que par l’art décoratif, elle explore la couleur, la matière et le détail pour créer des œuvres à la fois délicates et puissantes. Chaque toile est une invitation à la contemplation et à la rêverie, offrant un voyage immersif dans un monde de beauté fragile et mystérieuse — un univers de palais suspendus où chaque regard découvre des merveilles inattendues.</p>",
          note: "Vernissage : le mercredi 29 octobre 17h-20h",
        },
        {
          section: "2025",
          image: "img/expo/heloise-bonin.jpg",
          title: "Murmure du vivant",
          name: "Héloïse Bonin",
          name_link: "https://www.heloisebonin.com/",
          date: "01/09 - 25/10/2025",
          post_multiline:
            "Héloïse Bonin, nous immerge dans un monde où l’encre devient un souffle, où chaque trait est un fragment de forêt, un vestige de pierre, un murmure intime de la vie… Dans l’interstice entre geste et matière, cette exposition révèle la poésie silencieuse du vivant, portée par la force saisissante de l’encre.",
          note: "Vernissage : le 17 septembre 18h - 20h30",
        },
        {
          image: "img/expo/victor-magenta.jpg",
          title: "L'invention de la couleur",
          name: "Victor Magenta",
          name_link: "https://www.artiste-pasigraphe.fr/",
          date: "12/05 - 26/06/2025",
          note: "Vernissage : le 22 mai à partir de 18h",
        },
        {
          image: "img/expo/uraraka_2025.jpg",
          title: "Lustre des pigments japonais II",
          name: "Uraraka Matsuzawa",
          date: "12/03 - 26/04/2025",
          note: "Vernissage : le 20 mars à partir de 18h",
        },
        {
          image: "img/expo/meunier-curtinet.jpg",
          title: "Jean Meunier Curtinet",
          title_link: "https://www.facebook.com/profile.php?id=100011529817588",
          name: "08/01 - 28/02/2025",
          post_multiline:
            "Héritier des Nabis, les peintres post-impressionnistes<br>Un premier Prix de peinture à l’Ecole des Beaux-arts en 1975<br>L’une de ses œuvres trône à l’hôtel Négresco de Nice",
          note: "Vernissage : le jeudi 16 janvier à partir de 18h",
        },
        {
          section: "2024",
          image: "img/expo/alain-pagliano.jpg",
          title: "Alain PAGLIANO",
          name: "10/10 - 20/12/2024",
        },
        {
          image: "img/expo/favrene.jpg",
          title: "Favrène",
          title_link: "https://www.aralya.fr/expositions/favrene/",
          name: "30/08-30/09/2024",
        },
        {
          image: "img/expo/carole-gourrat.jpg",
          title: "Déambulations poétiques",
          name: "Carole Gourrat",
          name_link: "https://carolegourrat.com/",
        },
        {
          image: "img/expo/pascale-charrier-royer.jpg",
          title: "Couleurs de l'infini",
          name: "Pascale Charrier-Royer",
          name_link: "https://www.pascalecharrierroyer.site/",
        },
        {
          section: "2023",
          image: "img/expo/koba.jpg",
          title: "AU FIL DE L’ART",
          name: "Ariel KOBA",
          name_link: "https://koba.dictionnairedesartistescotes.com/",
        },
        {
          image: "img/expo/envol-des-zephyrs.jpg",
          title: "L’envol des Zéphyrs",
          name: "Christèle Lefay",
        },
        {
          image: "img/expo/bach.jpg",
          title: "Peintographies",
          name: "Dominique BACHMANN @peintographik",
        },
        {
          image: "img/expo/alkaplan.jpg",
          title: "Animérisme, couleur et résonance",
          post: "Membre sociétaire du Salon d'Automne de Paris",
          name: "Alkaplan (Bruno Pezon)",
          name_link:
            "https://www.i-cac.fr/artiste/alkaplan-bruno-pezon-dit-1.html",
        },
        {
          section: "2022",
          image: "img/expo/croisee-regards.jpg",
          title: "A la croisée des regards",
          post: "4 artistes lyonnaises",
          name_multiline:
            "<a href='https://www.facebook.com/Agapie.art/' target='_blank' rel='noopener noreferrer'>Agapie</a><br><a href='https://www.dehoux-grafmeyer.com/' target='_blank' rel='noopener noreferrer'>Danielle-Dehoux-Grafmeyer</a><br><a href='https://www.facebook.com/profile.php/?id=100017976825247' target='_blank' rel='noopener noreferrer'>Thoul</a><br><a href='https://www.pascalecharrierroyer.site/' target='_blank' rel='noopener noreferrer'>Pascale Charrier-Royer</a>",
        },
        {
          image: "img/expo/uraraka.jpg",
          title: "Lustre des pigments japonais",
          post: "Artiste de peinture japonaise",
          name: "Uraraka",
        },
        {
          image: "img/expo/foodisterie.jpg",
          title: "Foodisterie",
          post: "Photographe culinaire",
          name: "Maureen Domprobst",
        },
        {
          image: "img/expo/malfroy.jpg",
          title: "Tableaux en soie",
          post: "Société lyonnaise de la soierie",
          name: "Malfroy",
        },
        {
          image: "img/expo/aborigenes.jpg",
          title: "Rêves aborigènes",
          post: "Peintres aborigènes par coordination",
          name: "Walala Tjapaltjarri, Ken Brenton, Morris Gibson Tjapajarri, Maureen Hudson, Margaret Scobie,…",
        },
        {
          section: "2021",
          image: "img/expo/artistes-lyonnaises.jpg",
          title: "Eternité",
          post: "3 artistes lyonnaises",
          name: "Camille Guillaud, Miu Shinoda, Aude Marchal",
        },
        {
          image: "img/expo/franksan.jpg",
          title: "« Métamorphoses » in Miami",
          post: "Photographe lyonnais",
          name: "Franksan",
        },
      ],
    };
  },
  watch: {
    email(value) {
      this.validateEmail(value);
    },
  },
  methods: {
    sendEmail() {
      if (!this.email || this.msg["email"]) {
        this.errorMsg = "Veuillez entrer un email valide";
        this.successMsg = "";
        return;
      }

      const serviceId =
        process.env.VUE_APP_EMAILJS_SERVICE_ID;
      const templateId =
        process.env.VUE_APP_EMAILJS_TEMPLATE_ID;
      const publicKey = process.env.VUE_APP_EMAILJS_PUBLIC_KEY;

      if (!publicKey) {
        this.errorMsg =
          "Configuration EmailJS manquante: clé publique introuvable.";
        this.successMsg = "";
        return;
      }

      const templateParams = {
        email: this.email,
        user_email: this.email,
        from_email: this.email,
      };

      emailjs.send(serviceId, templateId, templateParams, publicKey).then(
        () => {
          this.email = "";
          this.msg = {};
          this.successMsg = "Votre email a bien été envoyé !";
          this.errorMsg = "";
        },
        (error) => {
          const details = error && (error.text || error.message);
          this.errorMsg = details
            ? `Une erreur est survenue: ${details}`
            : "Une erreur est survenue, veuillez réessayer.";
          this.successMsg = "";
          // Keep technical details in console for faster EmailJS debugging.
          console.error("EmailJS send error:", error);
        }
      );
    },
    validateEmail(value) {
      if (!value) {
        this.msg["email"] = "";
        return;
      }
      //eslint-disable-next-line
      if (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
        this.msg["email"] = "";
      } else {
        this.msg["email"] = "Veuillez entrer un email valide";
      }
    },
    toWebp(p) {
      if (!p) return p;
      return p.replace(/\.[^/.]+$/, ".webp");
    },
    toJpg(p) {
      if (!p) return p;
      return p.replace(/\.[^/.]+$/, ".jpg");
    },
  },
};
</script>
<style lang="scss">
.artist-link {
  text-decoration: underline;
}
$gray: #bababa;
.form {
  display: flex;
  flex-wrap: wrap;
  margin-top: 1rem;
  input,
  button {
    font-family: "Cormorant Garamond", serif;
    font-size: 1.6rem;
    margin-top: 1rem;
  }
  input {
    width: 20rem;
    height: 4rem;
    padding: 0 1rem;
    border: 1px solid $gray;
    border-radius: 0.5rem;
    margin-right: 1rem;
  }
  button {
    height: 4rem;
    padding: 0 1rem;
    border: 1px solid $gray;
    border-radius: 0.5rem;
    cursor: pointer;
  }
  .error {
    color: red;
    margin-top: 0.5rem;
    font-size: 1.4rem;
  }
}
.form-success {
  color: green;
  margin-top: 0.8rem;
  font-size: 1.4rem;
}
.form-error {
  color: red;
  margin-top: 0.8rem;
  font-size: 1.4rem;
}
</style>